import { DealType } from '~/src/dash/api/deals';
import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { TKey } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

interface ISticker {
  color: string;
  backgroundColor: string;
  tKey: TKey;
  tooltipTKey: TKey;
}

export const DealTypeToSticker = (dealType: DealType): ISticker => {
  switch (dealType) {
    case DealType.OpenAuction:
      return {
        color: publicaColors.jungleGreen,
        backgroundColor: publicaColors.honeydew,
        tKey: 'OpenAuction',
        tooltipTKey: 'OpenAuction',
      };
    case DealType.PrivateAuction:
      return {
        color: publicaColors.darkPurple,
        backgroundColor: publicaColors.lightLilac,
        tKey: 'PrivateAuction',
        tooltipTKey: 'PrivateAuction',
      };
    case DealType.ProgrammaticGuaranteed:
      return {
        color: publicaColors.blue,
        backgroundColor: publicaColors.lighterBlue,
        tKey: 'ProgrammaticGuaranteed',
        tooltipTKey: 'ProgrammaticGuaranteed',
      };
    case DealType.PreferredDeal:
      return {
        color: publicaColors.orange,
        backgroundColor: publicaColors.veryLightOrange,
        tKey: 'PreferredDeal',
        tooltipTKey: 'PreferredDeal',
      };
    default:
      return {
        color: publicaColors.veryDarkGray,
        backgroundColor: publicaColors.veryLightGray,
        tKey: 'Unknown',
        tooltipTKey: '',
      };
  }
};

export const DealTypeOptions: ISelectOption[] = [
  { id: DealType.OpenAuction, label: 'Open Auction', tKey: 'OpenAuction' },
  { id: DealType.PrivateAuction, label: 'Private Auction', tKey: 'PrivateAuction' },
  {
    id: DealType.ProgrammaticGuaranteed,
    label: 'Programmatic Guaranteed',
    tKey: 'ProgrammaticGuaranteed',
  },
  { id: DealType.PreferredDeal, label: 'Preferred Deal', tKey: 'PreferredDeal' },
];
